
<div class="district-container pt-20">
    <div class="cardList">
        <ng-container>
            <mat-card class="cardListItem small-height box-shadow">
                <mat-card-header>
                    <mat-card-title>{{headingTitle}}</mat-card-title>
                </mat-card-header>
                <mat-card-content><span *ngIf="disclaimer" class="disclaimer">{{disclaimer}}</span></mat-card-content>
            </mat-card>
            <mat-card *ngIf="electionService.isMobile===false" class="cardListItem small-height box-shadow">
                <mat-card-header>
                    <mat-card-title>Last updated</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2>{{lastUpdate | date:'dd MMM yyyy HH:mm'}}</h2>
                </mat-card-content>
            </mat-card>
        </ng-container>
    </div>
    <div class="cardList">
        <ng-container *ngIf="isMobile; else desktop">
            <mat-card class="cardListItem">
                <mat-card-header>
                    <mat-card-title>Votes won (first preferences)</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <first-preference-graph [chartTitle]="'Votes won (first preferences)'" [chartSubTitle]="''">
                    </first-preference-graph>
                    <first-preference-table></first-preference-table>
                </mat-card-content>
            </mat-card>
            <mat-card class="cardListItem">
                <mat-card-header>
                    <mat-card-title>{{ isFinal ? 'Seats Won' : 'Parties currently leading in districts' }}</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <hemicycle-graph [hideHeader]="true"></hemicycle-graph>
                    <parties-currently-leading-table *ngIf="!isFinal"></parties-currently-leading-table>
                    <seats-won-comparison-table *ngIf="isFinal"></seats-won-comparison-table>
                </mat-card-content>
            </mat-card>
            <mat-card class="cardListItem" *ngIf="!isFinal">
                <mat-card-header>
                    <mat-card-title>Count progress</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <count-progress-table></count-progress-table>
                </mat-card-content>
            </mat-card>
            <mat-card class="cardListItem">
                <mat-card-header>
                    <mat-card-title>Essential statistics</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <turnout-by-district></turnout-by-district>
                </mat-card-content>
            </mat-card>
            <mat-card class="cardListItem full-width">
                <mat-card-header class="align-center">
                    <mat-card-title>{{leadingByDistrictTitle}}</mat-card-title>
                </mat-card-header>
                <mat-card-content class="align-center">
                    <leading-candidate-chart [isFinal]="isFinal"></leading-candidate-chart>
                </mat-card-content>
            </mat-card>
        </ng-container>

        <!-- Mobile View  -->
        <ng-template #desktop>
          <mat-card class="cardListItem">
              <mat-card-header>
                  <mat-card-title>Votes won (first preferences)</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                  <first-preference-graph [chartTitle]="'Votes won (first preferences)'" [chartSubTitle]="''">
                  </first-preference-graph>
                  <first-preference-table></first-preference-table>
              </mat-card-content>
          </mat-card>
          <mat-card class="cardListItem">
              <mat-card-header>
                  <mat-card-title>{{ isFinal ? 'Seats Won' : 'Parties currently leading in districts' }}</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                  <hemicycle-graph [hideHeader]="true"></hemicycle-graph>
                  <parties-currently-leading-table *ngIf="!isFinal"></parties-currently-leading-table>
                  <seats-won-comparison-table *ngIf="isFinal"></seats-won-comparison-table>
              </mat-card-content>
          </mat-card>
          <mat-card class="cardListItem" *ngIf="!isFinal">
              <mat-card-header>
                  <mat-card-title>Count progress</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <count-progress-table></count-progress-table>
              </mat-card-content>
          </mat-card>
          <mat-card class="cardListItem">
              <mat-card-header>
                  <mat-card-title>Essential statistics</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                  <turnout-by-district></turnout-by-district>
              </mat-card-content>
          </mat-card>
          <mat-card class="cardListItem full-width">
              <mat-card-header class="align-center">
                  <mat-card-title>{{leadingByDistrictTitle}}</mat-card-title>
              </mat-card-header>
              <mat-card-content class="align-center">
                  <leading-candidate-chart [isFinal]="isFinal"></leading-candidate-chart>
              </mat-card-content>
          </mat-card>
        </ng-template>
    </div>
</div>
